import React, {useState} from 'react';

export default function CatalogSearch({booksLike, authorsLike, setBooksLike, setAuthorsLike}) {
    const [mode, setMode] = useState('books');
    const query = (mode === 'books' ? booksLike : authorsLike) || '';
    const setQuery = value => mode === 'books' ? setBooksLike(value) : setAuthorsLike(value);
    const changeMode = next => {
        setBooksLike(next === 'books' ? query : '');
        setAuthorsLike(next === 'authors' ? query : '');
        setMode(next);
    };
    return <div className="catalog-search" role="search" aria-label="Поиск в каталоге">
        <label className="visually-hidden" htmlFor="catalog-search-mode">Искать</label>
        <select id="catalog-search-mode" className="form-select" value={mode}
                onChange={event => changeMode(event.target.value)}>
            <option value="books">Книги</option>
            <option value="authors">Авторы</option>
        </select>
        <label className="visually-hidden" htmlFor="catalog-search-query">
            {mode === 'books' ? 'Название книги' : 'Имя автора'}
        </label>
        <input id="catalog-search-query" className="form-control" type="search" value={query}
               placeholder={mode === 'books' ? 'Название книги' : 'Имя автора'}
               onChange={event => setQuery(event.target.value)}/>
        <p className="catalog-search-help">Результаты обновляются после ввода.</p>
    </div>;
}
